function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import globalHelperFactory from './global-helper';
import { AllhomesGlobalContext } from './allhomes-global-context';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Provider = AllhomesGlobalContext.Provider;
export class AllhomesGlobalContextProvider extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "globalHelper", void 0);
    this.globalHelper = globalHelperFactory(this, props);
    this.state = this.globalHelper.buildState();
  }
  componentDidMount() {
    this.globalHelper.setUp();
  }
  componentWillUnmount() {
    this.globalHelper.tearDown();
  }
  render() {
    return ___EmotionJSX(Provider, {
      value: this.state
    }, this.props.children);
  }
}